// 스토어 대시보드용 Doughnut chart wrapper (vue-chartjs v3 + chart.js v2).
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options);
    },
    options() {
      this.renderChart(this.chartData, this.options);
    },
  },
};
